import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function LabellingSystems() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        Identification & Labelling Systems UAE | Cable & Equipment Labels | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides durable identification and labelling systems in the UAE for cables, wires, pipes, valves, equipment and industrial components, including thermal labels, heat shrink markers, ID plates, pipe markers and valve tags."
    />

    <meta
        name="keywords"
        content="identification labelling systems UAE, cable labels UAE, cable identification UAE, industrial labelling UAE, wire markers UAE, heat shrink cable markers UAE, equipment ID plates UAE, valve tags UAE, pipe markers UAE, safety labels UAE, thermal transfer printers UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/LabellingSystems"
    />

    <meta
        property="og:title"
        content="Identification & Labelling Systems UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Clear and durable identification solutions for cables, wires, pipes, valves, equipment and industrial components across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/LabellingSystems"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Identification & Labelling Systems</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Clear, durable labeling for organized and traceable wiring.
                    </p>
                </div>
            </div>
            {/* <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="mt-[91px] overflow-hidden relative"
            >
                <motion.img
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                    src="/assets/service/bg3.png"
                    className="w-full lg:h-auto h-[300px] object-cover"
                    alt="	Trusted cable management and termination solutions provider in the UAE"
                />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] left-1/2 -translate-x-1/2">
                    <motion.h6
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.7 }}
                        className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]"
                    >
                        Identification & Labelling Systems
                    </motion.h6>
                    <motion.p
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.7 }}
                        className="max-w-[582px] w-full font-[300] font-inter text-[20px] leading-[30px] text-[#FFFFFF]"
                    >
                        Clear, durable labeling for organized and traceable wiring.
                    </motion.p>
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]"
                >
                    Labelling Systems
                </motion.h1>
            </motion.div> */}

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[80px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/product5.png' />
                    </div>


                </div>

                <div className='detail-div-right'>
                    <h3>Identification & Labelling Systems</h3>

                    {/* <p>I've designed and animated a product detail page for a luxury e-commerce platform, focusing on delivering a seamless and premium user experience.</p> */}


                    <h4></h4>

                    <br />
                    <div className='lines'></div>
                    <br />
                    <div className='detail-des'>
                        <p>Description :</p>

                        <h5>Identification & Labelling Systems are critical for ensuring clear, accurate, and long-lasting identification of cables, wires, components, and equipment. These systems enhance safety, streamline maintenance, and support efficient troubleshooting by making installations easy to navigate. Available in various formats like heat shrink sleeves, adhesive labels, engraved tags, and clip-on markers, they are designed to withstand harsh industrial environments, including exposure to heat, moisture, and chemicals. Whether in control panels, field wiring, or large-scale installations, proper labeling ensures compliance, organization, and operational reliability.</h5>
                        <br />

                        <div className='detail-div-p'>
                            <h3>Labels, Tags & ID Plates</h3>

                            <p>
                                Available in sheets and rolls in various colours, sizes and materials.
                                <br />
                                <br />	Laser Labels in A4 sheets for standard office printer
                                <br />	Thermal Printed Tags - Yellow/White/Blue/Red coloured
                                <br />	Emboss – Stainless Steel Tags
                                <br />	Laser Engraved on all metals except Aluminium
                                <br />	Engraved – Traffolyte, Stainless Steel, Brass etc.
                                <br />	Self-Laminating Labels
                                <br />	Ferrule Marking Tubes
                                <br />	Shrinkable Cable & Wire markers
                                <br />	Safety Signs ISO 7010 compliant
                                <br />	ID Plates – Aluminium, Engraved Plastic & Stainless Steel
                            </p>
                            <br />
                            <h3>Printers, Software’s & Ribbons </h3>

                            <p>
                                Printers are available in various configurations – handheld, portable and industrial with factory installed software for efficient functioning. Ribbons are available in different sizes and colours.
                                <br /><br />
                                Thermal Transfer Printers
                                <br />	Embossing Printer
                                <br />	Laser Printers
                            </p>
                            <br />
                            <h3>Pipe Markers </h3>

                            <p>
                                Pipe identification labels are available to satisfy safety and ASME A 13.1 or ISO 20560-1 standards. The use of basic identification colours and warning symbols helps us to identify the pipeline contents and hazards. Factors such as chemical type, pipe diameter and flow direction determine the style and colour. There are 3 different sizes of pipe markers determined by pipe diameter – up to 150mm, 150mm to 500mm and greater than 500mm
                                <br /><br />	Self-Adhesive Pipe Markers
                                <br />	Coiled Pipe Markers
                                <br />	Carrier Pipe Markers
                            </p>
                            <br />
                            <h3>Equipment ID Plates

                            </h3>

                            <p>
                                These are durable equipment name plates and asset tags for any application to identify the equipment, machinery, tools etc. This can be used for naming, numbering equipment, conveying instruction, warning personnel of danger, mapping facilities and more. Depending upon the usage – indoor, outdoor, harsh environment, chemicals etc various grades of materials are in use</p>
                            <br />
                            <h3>Valve Tags </h3>

                            <p>
                                Traffolyte, Brass, Anodized Aluminium and Stainless Steel are extensively used as valve tags where environmental conditions demand both long term durability and clarity. Unaffected by water and damp conditions. Traffolyte can offer a wide choice of colours that resist fading. We offer variety of valve tag fixing:
                                <br /><br />o	Stainless Steel Wire – Nylon coated stainless steel wire in conjunction with aluminium ferrules is recommended for strong, durable, permanent, vibration and movable conditions both for interior and exterior use.
                                <br />	Ball & Chain – Easy to fix and adjust are extensively used in plumbing applications to fix tags on pipe works. Not recommended for exterior use or corrosive environments
                            </p>
                            <p> We offer solutions for the identification of wires, cables, pipes, valves, equipment's, components and indus-try.
                                Labels in A4 sheets for standard office printer</p>

                            <ul className='pt-[40px]'>
                                <li>Thermal Printed Tags
                                </li>
                                <li>Self-Laminating Labels
                                </li>
                                <li>Ferrule Marking Tubes
                                </li>
                                <li>Shrinkable Cable & Wire Markers
                                </li>
                                <li>Thermal Transfer Printer
                                </li>
                                <li>Ribbons & Accessories
                                </li>
                                <li>Emboss - Stainless Steel Tags
                                </li>
                                <li>Laser Engraved on all metals except Al
                                </li>
                                <li>Safety Signs & Labels
                                </li>
                                <li>Equipment ID Plates
                                </li>
                                <li>Valve Tags
                                </li>
                                <li>Emboss Printer
                                </li>
                                <li>Laser Printer
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default LabellingSystems